import { createSlice } from '@reduxjs/toolkit'
import Cookie from 'js-cookie'
export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        token: '',
        saleSession: null,
        signedIn: false,
    },
    reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
            Cookie.set('token', action.payload, {
                expires: 1,
                secure: true,
                sameSite: 'None',
            })
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
            state.saleSession = null
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
        setSessionStart: (state, action) => {
            state.saleSession = action.payload
        },
    },
})

export const { onSignInSuccess, onSignOutSuccess, setToken, setSessionStart } =
    sessionSlice.actions

export default sessionSlice.reducer
